export default function ShareIcon() {
  return (
    <g
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      clipPath='url(#clip0_5298_66145)'>
      <path d='M2 8a2 2 0 104 0 2 2 0 00-4 0zM10 4a2 2 0 104 0 2 2 0 00-4 0zM10 12a2 2 0 104 0 2 2 0 00-4 0zM5.797 7.134l4.4-2.267M5.797 8.867l4.4 2.267'></path>
    </g>
  );
}
